module.exports = global["surveylab_page_numberSlider"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./number-slider.ts");